<div class="flex flex-col" *ngIf="status$ | async as status">
  <vi-loader
    *ngIf="status === vdzFormStatus.Loading"
    [isLoading]="true"
    [titleKey]="'+INSTALLATIONS.SRC.VDZ_FORM.LOADING.TITLE' | translate"
  ></vi-loader>

  <ng-container *ngIf="status === vdzFormStatus.Ready">
    <div class="w-full">
      <app-pdf-preview
        *ngIf="pdfUrl"
        [src]="pdfUrl"
        [originalSize]="false"
        [showBorders]="true"
        [zoom]="0"
        [showAll]="false"
        [autoresize]="true"
        [allowNavigation]="true"
        [allowZoomScale]="true"
        [allowDownload]="false"
        gtm="onClick"
        gtmAction="Navigate VdZ form"
        gtmCategory="srcDetails"
        [page]="1"
        [documentTitle]="'+INSTALLATIONS.SRC.VDZ_FORM.TITLE' | translate"
      ></app-pdf-preview>
    </div>

    <!-- Download button -->
    <div class="flex justify-end pt-4">
      <button
        (click)="download()"
        mat-raised-button
        color="primary"
        gtm="onClick"
        gtmAction="Download VdZ form"
        gtmCategory="srcDetails"
      >
        <mat-icon iconPositionStart>download</mat-icon>
        <span>{{ '+INSTALLATIONS.SRC.VDZ_FORM.DOWNLOAD_BUTTON' | translate }}</span>
      </button>
    </div>
  </ng-container>
</div>
